module.exports = __webpack_public_path__ + "static/media/opt_lbd_pro_new_thumbnail.97bf7e62.jpg";